import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import { api_GET } from "../services/api_service.js";
import { getSessionCookie, getTokenCookie } from "../services/session.js";

import routes from "../routes.jsx";

import { Chat } from "constants/chat";

class MapaOrdem extends React.Component {

  componentDidMount () {
    Chat();
  }

  componentDidUpdate(e) {    
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
    this.validaPermissaoAcesso();
  }

  validaPermissaoAcesso = () => {
    let session = getSessionCookie();  
    var token = getTokenCookie();

    if (session === null || token === null) {
      this.props.history.push("/auth/login");
      return false;      
    }
    
    if (token.expired){
      this.props.history.push("/auth/login");  
      return false;      
    }

    if (session.perfil == "Master")
      return;
    
    api_GET(`usuario/GetPermissaoAcesso/${session.usuarioId}/${this.props.history.location.pathname.split("/")[2]}`).then(result => {            
      if (result.status !== 200) {
        this.props.history.goBack();
      }
      else if (result.data == null){
        this.props.history.goBack();
      }
    });
  }
  
  getRoutes = routes => {
    this.validaPermissaoAcesso();
    return routes.map((prop, key) => {
      if (prop.layout === "/mapaordem") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    return (
      <>
        <div className="main-content" ref="mainContent">          
          <Switch>
            {this.getRoutes(routes)}            
          </Switch>          
        </div>
      </>
    );
  }
}

export default MapaOrdem;
